/* eslint-disable import/prefer-default-export */
/**
 * Reads content from a public URL file
 * @param url Public URL of the file
 * @returns Content of the file or null if there's an error
 */
export const readFileContent = async (url: string): Promise<string | null> => {
  try {
    const response = await fetch(url);

    // Check if response is OK (status 200-299)
    if (!response.ok) {
      // eslint-disable-next-line no-console
      console.error(`HTTP error! Status: ${response.status}`);
      return null;
    }

    // Read the file content
    const content = await response.text();
    // eslint-disable-next-line no-console
    return content;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error reading file:', error);
    return null;
  }
};
